import { createSlice } from "@reduxjs/toolkit";

const initialState = {
subscriptionData: null,
};
const userSubscriptionInfoSlice = createSlice({
  name: "userSubscriptionInfo",
  initialState,
  reducers: {
    setSubscriptionData: (state, action) => {
      state.subscriptionData = action.payload;
    },
  },
});

export const { setSubscriptionData } = userSubscriptionInfoSlice.actions;

export default userSubscriptionInfoSlice;